module.exports = __webpack_public_path__ + "static/img/04.42ecc16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/04.png
// module id = 4cVH
// module chunks = 1